import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <CarouselSection />
        <RankingSection />
        <CommentsSection />
        <FeaturesSection />
        <IndexSection />
        <MediaSection />
        <FaqSection />
        <AppSection />
        <UpdatesSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}